<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Solicitantes</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Solicitantes',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="$check(['requesters.create'])" id="btnNew" type="button" color="primary" elevation="0"
                            to="/solicitantes/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="applyFilter">
                            <v-row>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense label="E-mail" v-model="dataList.filter.email" hide-details
                                        outlined clearable></v-text-field>
                                </v-col>
                               
                                <v-col cols="12" sm="4">
                                    <v-autocomplete dense label="Empresa" :items="dataset.customers"
                                        v-model="dataList.filter.customer_id" item-value="id" item-text="name" outlined
                                        hide-details :loading="dataset.customerLoading"
                                        :search-input.sync="searchCustomer" cache-items :filter="() => true"
                                        no-data-text="Nenhuma empresa encontrada" clearable></v-autocomplete>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                    <v-btn id="btnClear" type="button" color="grey darken-1" text class="ml-2"
                                        @click="clearFilter">Limpar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:options="optionsChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum solicitante encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">


                            <template v-slot:[`item.profile`]="{ item }">
                                <span v-if="item.profile">{{ item.profile | enum(dataset.adminProfiles, 'id', 'name')
                                    }}</span>
                                <span v-else>N/A</span>
                            </template>

                            <template v-slot:[`item.customers`]="{ item }">
                                <span v-if="item.customers">{{ formatCustomers(item) }}</span>
                                <span v-else>N/A</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['requesters.update'])" class="ml-2" v-on="on" @click="viewItem(item)" size="large">
                                                <!-- <v-icon v-on="on" size="large"> -->
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar solicitante</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['requesters.delete'])" class="ml-2" v-on="on" @click="deleteItem(item)" size="large">
                                                <!-- <v-icon v-on="on" size="large"> -->
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover solicitante</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import adminProfiles from '@/common/data/admin-profiles.data'

import object from "@/common/util/object"
import debounce from 'lodash/debounce'

Vue.use(VueLodash)

const STORAGE_KEY = 'requesterList.state';

function loadState() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (_) {
        return {};
    }
}

function saveState(state) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_) { /* storage indisponível */ }
}

export default {
    name: "RequestList",

    data: () => ({
        dataset: {
            data: {},
            customers: [],
            customerLoading: false,
            adminProfiles: adminProfiles
        },
        searchCustomer: '',
        lastQueryKey: null,
        dataList: {
            filter: {
                name: '',
                email: '',
                customer_id: null,
            },
            headers: [
                { text: "ID", value: "id" },
                { text: "Nome", value: "name" },
                { text: "Cargo", value: "profile" },
                { text: "Email", value: "email" },
                { text: "Empresas", value: "customers" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
    }),

    created() {
        this.restoreState();
        this.load(true);
    },

    watch: {
        searchCustomer(val) {
            this.loadCustomers(val);
        },
    },

    methods: {
        restoreState() {
            const state = loadState();

            if (state.filter) {
                this.dataList.filter = { ...this.dataList.filter, ...state.filter };
            }

            if (state.customer && state.customer.id) {
                this.dataset.customers = [state.customer];
                this.dataList.filter.customer_id = state.customer.id;
            }

            if (state.options) {
                this.dataList.options = { ...this.dataList.options, ...state.options };
            }
        },

        persistState() {
            const customerId = this.dataList.filter.customer_id;
            const stored = loadState().customer;
            const customer = this.dataset.customers.find((x) => x.id === customerId)
                || (stored && stored.id === customerId ? stored : null);

            saveState({
                filter: { ...this.dataList.filter },
                customer: customer ? { id: customer.id, name: customer.name } : null,
                options: {
                    page: this.dataList.options.page,
                    itemsPerPage: this.dataList.options.itemsPerPage,
                },
            });
        },

        optionsChanged(options) {
            this.dataList.options.page = options.page;
            this.dataList.options.itemsPerPage = options.itemsPerPage;
            this.load();
        },

        applyFilter() {
            this.dataList.options.page = 1;
            this.load(true);
        },

        clearFilter() {
            this.dataList.filter = { name: '', email: '', customer_id: null };
            this.applyFilter();
        },

        buildQueryKey() {
            return JSON.stringify({
                page: this.dataList.options.page,
                limit: this.dataList.options.itemsPerPage,
                filter: this.dataList.filter,
            });
        },

        loadCustomers: debounce(async function (filter = '') {
            this.dataset.customerLoading = true;

            try {
                const result = await axios.get('api/v2/customers', { params: { start: 0, limit: 10, search: { name: filter } } });

                this.dataset.customers = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.customerLoading = false;
            }
        }, 500),

        formatCustomers(item) {
            const customers = item.customers.filter((x) => x.customer).map((x) => x.customer.name);

            if (!customers.length) return 'N/A';

            if (customers.length == 1) return customers[0];

            return `${customers[0]} +${customers.length - 1}`

        },

        async load(force = false) {
            const key = this.buildQueryKey();

            // O v-data-table emite update:options ao montar e ao trocar página/itens por página;
            // evita carregar duas vezes a mesma consulta.
            if (!force && key === this.lastQueryKey) return;

            this.lastQueryKey = key;
            this.persistState();

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            const limit = this.dataList.options.itemsPerPage;
            const page = this.dataList.options.page;

            this.dataList.loading = true;

            try {
                const result = await axios.get(`/api/v2/requesters`, {
                    params: {
                        page: page,
                        limit: limit,
                        search
                    }
                });

                console.log("Dados: ", result)

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`solicitantes/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir solicitante',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`api/v2/requesters/${item.id}`)

                this.$dialog.notify.info("Solicitante excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },

    },
};
</script>
